import { isExternalOptionsEnum } from './isExternalOptionsEnum';
import { isExternalOptionsField } from './isExternalOptionsField';
import { ENUMERATION, STRING, NUMBER } from 'customer-data-objects/property/PropertyTypes';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { List } from 'immutable';
export const isOperatorIncompatibleWithExternalOptionsField = (condition, filterFamily, getOperatorsForType, getIsUngated) => {
  const {
    field
  } = condition;
  const isExternalOptionsStringOrNumber = field && isExternalOptionsEnum(field, getIsUngated) && isExternalOptionsField(field, filterFamily, getIsUngated);
  if (isExternalOptionsStringOrNumber) {
    const enumOperators = getOperatorsForType(ENUMERATION, filterFamily, getIsUngated);
    // if filter is using enumeration operators, it is compatible
    if (enumOperators) {
      return !enumOperators.includes(condition.constructor);
    }
  }
  return false;
};
export const shouldUseEnumComponentsForExternalOptionsField = (field, condition, filterFamily, getOperatorsForType, getIsUngated) => {
  const isExternalOptionsStringOrNumber = isExternalOptionsEnum(field, getIsUngated) && isExternalOptionsField(field, filterFamily, getIsUngated);
  if (isExternalOptionsStringOrNumber) {
    // if net new filter, it should use enumeration components
    const isNewFilter = !condition;
    if (isNewFilter) {
      return true;
    }

    // if existing filter is using enumeration operators, it should use enumeration components
    const enumOperators = getOperatorsForType(ENUMERATION, filterFamily, getIsUngated);
    if (enumOperators !== null && enumOperators !== void 0 && enumOperators.includes(condition.constructor)) {
      return true;
    }
  }
  return false;
};
const operatorMappingNumberToEnumeration = {
  Equal: Operators.In,
  NotEqual: Operators.NotIn,
  EverEqual: Operators.EverIn,
  NeverEqual: Operators.NeverIn
};
const fromNumberToEnumeration = condition => {
  const {
    name: operator,
    field,
    value: numberValue
  } = condition;
  const newOperator = operatorMappingNumberToEnumeration[operator];
  if (!newOperator || !field) {
    return undefined;
  }
  const value = List.of(`${numberValue}`);
  const newFilter = newOperator.of(field, value);
  return newFilter;
};
const operatorMappingStringToEnumeration = {
  EqualAny: Operators.In,
  NotEqualAny: Operators.NotIn,
  EverEqualAny: Operators.EverIn,
  NeverEqualAny: Operators.NeverIn
};
const fromStringToEnumeration = condition => {
  const {
    name: operator,
    field,
    value
  } = condition;
  const newOperator = operatorMappingStringToEnumeration[operator];
  if (!newOperator || !field) {
    return undefined;
  }
  const newFilter = newOperator.of(field, value);
  return newFilter;
};
const converters = {
  fromNumberToEnumeration,
  fromStringToEnumeration
};
export const attemptToConvertExternalOptionsFilter = condition => {
  var _condition$field;
  if (!condition) {
    return undefined;
  }

  // if using "or is empty" don't convert, target operator might not support it
  if (condition.defaultNullValue.includeObjectsWithNoValueSet) {
    return undefined;
  }
  const type = (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.type;
  if (type === STRING) {
    return converters.fromStringToEnumeration(condition);
  } else if (type === NUMBER) {
    return converters.fromNumberToEnumeration(condition);
  }
  return undefined;
};